import React, { PureComponent } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import {
  getRecoveryPlan,
  getRecoveryStats,
} from '../../redux/reducers/recovery';
import { getUserSkills } from '../../redux/reducers/skills';
// components
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ProgressChart from './components/ProgressChart';
import ProgressIndicators from './components/ProgressIndicators';
import RecoveryClock from './components/RecoveryClock';
import Preloader from '../../components/Preloader/Preloader';
import Goals from './components/Goals';
import StressTable from './components/StressTable';
import RecoveryCalendar from './components/RecoveryCalendar';
import ValuesChart from './components/ValuesChart';
import Triggers from './components/Triggers';
import Blockers from './components/Blockers';
import Breakers from './components/Breakers';
import Motivators from './components/Motivators';
import Statement from './components/Statement';
import Calendar from '../../components/Calendar/Calendar';
// utils
import { getSkillsAccess } from '../Routes/utils';
import { prepareChartData } from './utils';
import moment from 'moment';
// prop-types
import userShape from '../../shapes/user';
// styles
import styles from './RecoveryPlan.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class RecoveryPlan extends PureComponent {
  componentDidMount() {
    const {
      getRecoveryPlan,
      getUserSkills,
      getRecoveryStats,
      user,
      skills,
    } = this.props;
    if (user.progress.subscription) {
      const shouldFetchSkills = getSkillsAccess(user) && !skills;
      const filter = {
        filter: {
          start_date: moment()
            .subtract(1, 'months')
            .startOf('month')
            .format('DD-MM-YYYY'),
          stop_date: moment().format('DD-MM-YYYY'),
        },
      };
      getRecoveryStats(filter);
      shouldFetchSkills && getUserSkills();
    }
    getRecoveryPlan();
  }

  render() {
    const {
      user,
      isRecoveryLoading,
      isSkillsLoading,
      isLoaded,
      impact,
      blockers,
      breakers,
      motivators,
      satisfaction,
      risk,
      stress,
      valueChart,
      triggers,
      clock,
      skills,
      recoveryStats,
    } = this.props;

    const isSupport = user.role === 'support';
    const userData = isSupport ? user.client_person : user;
    const userColor = userData.profile_color || '#7fe7ab';
    const chartData = prepareChartData(satisfaction, risk);
    const placeholder = 'This will be accessed in module';
    const hasSkillAccess = getSkillsAccess(user);
    const isLoading = isRecoveryLoading || isSkillsLoading;

    return (
      <PageWrapper className={cx('wrapper')}>
        <h2 className="text-center mb-10">Recovery Plan</h2>
        <Preloader custom isActive={isLoading} className="mt-50" />
        <RecoveryClock />
        {isLoaded && (
          <div className="row">
            <div className={cx('col-md-6', 'full-width')}>
              <section>
                {hasSkillAccess && (
                  <RecoveryCalendar events={skills} color={userColor} />
                )}
              </section>
              <section>
                <h3>Why I am Here</h3>
                <Statement
                  statement={userData.statement}
                  userColor={userColor}
                  id={userData.id}
                />
              </section>
              <Goals userColor={userColor} />
              <Triggers
                triggers={triggers}
                placeholder={placeholder}
                userColor={userColor}
              />
              <Blockers
                blockers={blockers}
                placeholder={placeholder}
                userColor={userColor}
              />
              <Breakers
                breakers={breakers}
                placeholder={placeholder}
                userColor={userColor}
              />
              <Motivators
                motivators={motivators}
                placeholder={placeholder}
                userColor={userColor}
              />
            </div>
            <div className="col-md-6">
              <section>
                <h3>Daily Check-in</h3>
                <Calendar
                  color={userColor}
                  recoveryStats={recoveryStats}
                  isDailyCheckIn={true}
                />
              </section>
              <section>
                <h3>Progress over time</h3>
                <ProgressChart data={chartData} userColor={userColor} />
              </section>
              <section>
                <h3>Impact and Statistics</h3>
                <ProgressIndicators
                  userColor={userColor}
                  impact={impact}
                  userStats={clock.user_statistic}
                />
              </section>
              <StressTable
                userColor={userColor}
                stress={stress}
                placeholder={placeholder}
              />
              <ValuesChart
                userColor={userColor}
                valueChart={valueChart}
                placeholder={placeholder}
              />
            </div>
          </div>
        )}
      </PageWrapper>
    );
  }
}

RecoveryPlan.propTypes = {
  user: userShape,
  isRecoveryLoading: T.bool.isRequired,
  valueChart: T.arrayOf(T.object),
  isSkillsLoading: T.bool.isRequired,
  isLoaded: T.bool.isRequired,
};

export default connect(
  state => ({
    user: state.auth.user,
    isRecoveryLoading: state.recovery.isLoading,
    isSkillsLoading: state.skills.isLoading,
    isLoaded: state.recovery.isLoaded,
    impact: state.recovery.impact,
    breakers: state.recovery.breakers,
    motivators: state.recovery.motivators,
    triggers: state.recovery.triggers,
    satisfaction: state.recovery.satisfaction,
    risk: state.recovery.risk,
    blockers: state.recovery.blockers,
    stress: state.recovery.stress,
    valueChart: state.recovery.valueChart,
    clock: state.recovery.clock,
    skills: state.skills.userSkills,
    recoveryStats: state.recovery.recoveryStats,
  }),
  { getRecoveryPlan, getUserSkills, getRecoveryStats }
)(RecoveryPlan);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/RecoveryPlan.jsx